import {
  PATIENT_INFORMATION_SEARCH, PATIENT_INFORMATION_SEARCH_SUCCESS, PATIENT_INFORMATION_SEARCH_FAILURE, CLEAR_PATIENT_INFORMATION_SEARCH_PARAMS
} from './mutation-types'

export default {
  state: {
    patientInfos: null,
    patientInfosCurrentPage: 1,
    patientInfosNextPage: null,
    searchParams: null
  },
  getters: {
    patientInfos: state => {
      return state.patientInfos
    },
    patientInfosCurrentPage: state => {
      return state.patientInfosCurrentPage
    },
    patientInfosNextPage: state => {
      return state.patientInfosNextPage
    },
    patientInformationSearchParams: state => {
      return state.searchParams
    }
  },
  actions: {
    [PATIENT_INFORMATION_SEARCH] ({dispatch, state, commit}, params = null) {
      var url = '/changes'
      var data = {}
      if (params) {
        if (params.url && !params.clear) {
          url = params.url
        }
        if (params.clear) {
          state.patientInfos = null
          state.patientInfosCurrentPage = 1
          state.patientInfosNextPage = null
        }
        data = params.data
      }

      state.searchParams = data
      dispatch('apiGet', {url: url, data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(PATIENT_INFORMATION_SEARCH_FAILURE, res.data)
          } else {
            commit(PATIENT_INFORMATION_SEARCH_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [CLEAR_PATIENT_INFORMATION_SEARCH_PARAMS] ({state}) {
      state.searchParams = null
    }
  },
  mutations: {
    [PATIENT_INFORMATION_SEARCH_FAILURE] (state, data) {
      console.log('PATIENT_INFORMATION_SEARCH_FAILURE')
    },
    [PATIENT_INFORMATION_SEARCH_SUCCESS] (state, data) {
      console.log('PATIENT_INFORMATION_SEARCH_SUCCESS')
      if (data.meta && data.meta['current-page'] && data.meta['current-page'] > 1) {
        state.patientInfos = state.patientInfos.concat(data.data)
        state.patientInfosCurrentPage = data.meta['current-page']
      } else {
        state.patientInfos = data.data
        state.patientInfosCurrentPage = 1
      }
      if (data.links && data.links['next']) {
        state.patientInfosNextPage = data.links['next']
      } else {
        state.patientInfosNextPage = null
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/patient-information.js